const COOKIE_TOKEN_NAME = 'token';
const COOKIE_FIRST_TIME_REGISTERED = 'firstTimeRegister';

export {
    COOKIE_TOKEN_NAME,
    COOKIE_FIRST_TIME_REGISTERED
}
